module.exports = __webpack_public_path__ + "static/img/ic_zxsy.f88b351.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_zxsy.png
// module id = ZODH
// module chunks = 15